import React from 'react';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';

interface FooterProps {
  onClose: () => void;
}

const Footer = ({ onClose }: FooterProps) => {
  return (
    <div className="flex justify-start px-8 py-4">
      <Button type={ButtonType.outline} onClick={onClose}>
        &lt; Back
      </Button>
    </div>
  );
};

export default Footer;
